module.exports = __webpack_public_path__ + "img/download-white.ca3bd6ad.svg";